
/**
 * Function that calculates a distance between 2 locations, save it in a custom function and call a custom callback
 * @param  {object} origin                  first location
 * @param  {object} destination             second location
 * @param  {function} savingMethod          method for saving the distance to state
 * @param  {string} stateName               name of the state to be saved
 * @param  {function} callbackCalbackFunction function to be executed after saving the state
 * @return {integer}                         distance (this is not used currently, but it can not hurt to have it :))
 */
function calculateAndStoreDistance( origin, destination, savingMethod, stateName,callbackCalbackFunction ) {

  // Calling matrix 
  const distanceService = new window.google.maps.DistanceMatrixService();

  // Asking matrix to calculate the distance in imperial units by driving rute
  distanceService.getDistanceMatrix(
    {
      origins: [origin],
      destinations: [destination],
      travelMode: window.google.maps.TravelMode.DRIVING, 
      unitSystem: window.google.maps.UnitSystem.IMPERIAL,
      avoidHighways: false,
      avoidTolls: false
    }, callback( savingMethod, stateName, callbackCalbackFunction));
  
}
/**
 * Function that is called after the matrix gives result
 * @param  {function} savingMethod          method for saving the distance to state
 * @param  {string}   stateName               name of the state to be saved
 * @param  {function} callbackCalbackFunction function to be executed after saving the state
 * @return {Function} returning a function in order to pass paramters and get response from matrix
 */
function callback( savingMethod, stateName, callbackCalbackFunction ) {
  return function(response, status) {
    // Define distance za 0 in case it can not be calculated (API Key is not working for example)
    let distance = 0;
    let timeEstimate = 0;

    // If there is an error console log it
    if (status !== window.google.maps.DistanceMatrixStatus.OK) {
      console.log('error with matrix');
    } 

    else {
      let origin = response.originAddresses[0];
      let destination = response.destinationAddresses[0];
      
      // If there are no roads console log the error
      if (response.rows[0].elements[0].status === "ZERO_RESULTS") {
        console.log('Better get on a plane. There are no roads between ' 
                          + origin + 'and' + destination);
      } else {
        //If everything is ok get the distance, store it in the variable and console log it
        let returnedDistance = response.rows[0].elements[0].distance;
        let distance_value = returnedDistance.value;
        // let distance_text = returnedDistance.text;  

        distance = ( Math.round( ( distance_value / 1609.344) * 100 ) / 100 );
       

        let returnedTimeEstimate = response.rows[0].elements[0].duration;
        let timeEstimate_value = returnedTimeEstimate.value;
        // let timeEstimate_text = returnedTimeEstimate.text;

        timeEstimate = Number( timeEstimate_value / 3600 );
        

      }

      // Calling passed function for saving the distance to state
      savingMethod({
        [stateName]: {distance : distance, timeEstimate: timeEstimate}
        }, callbackCalbackFunction);

      return({distance : distance, timeEstimate: timeEstimate});
    }
  }
}

export default calculateAndStoreDistance;



// WEBPACK FOOTER //
// ./src/common/CalculateDistance.js